import * as MoecoSdkLib from '@/js/packages/moecoSdk-sdk/kotlin/moecoSdk-sdk.js'

// Logger
// service d0230000-8e41-4474-ad8b-bfb027b20667
// char d0230001-8e41-4474-ad8b-bfb027b20667
// people counter
// const characteristic = "000002b1-7f70-11e3-81c0-0002a5d5c51b";
// const service = "000002b0-7f70-11e3-81c0-0002a5d5c51b";

import { Buffer } from 'buffer';

const { moecoCompletable, moecoObservable, moecoSingle } = MoecoSdkLib.io.moeco.sdk;
const { BleConnectionState } = MoecoSdkLib.io.moeco.sdk.bluetooth.connection;
const { BleConnectedState, BleDisconnectedState } = BleConnectionState;

const getTimestamp = () => {
  return Math.round(new Date().getTime() / 1000).toString()
}

const consoleLog = (msg) => {
  console.log(`${getTimestamp()}:${msg}`);
}

/**
 * @param {String} sensorUid - hex string of sensor uid (example:"2b89febe07e3" )
 */
const startScan = async (sensorUid) => {
  try {
    const device = await navigator.bluetooth.requestDevice({
      filters: [
        {
          manufacturerData: [
            {
              companyIdentifier: 0x07b2,
              dataPrefix: Uint8Array.from(Buffer.from(sensorUid, 'hex'))

              // dtaPrefix: Uint8Array.from(Buffer.from("2b89febe07e3", 'hex'))
            }
          ]
        }
      ],
      optionalServices: ['d0230000-8e41-4474-ad8b-bfb027b20667']
    });

    consoleLog('device requested')
    return device;
  } catch (error) {
    console.log('error', error);
    throw error;
  }
}

// ws://dev-iu2.moeco.ninja:9900/


class BleConnection {
  constructor(bleDevice, gattServer) {
    consoleLog('constructor')

    this.gattServer = gattServer;
    this.bleDevice = bleDevice;

    // this.gattService = null;
    // this.gattCharacteristic = null;
  }

  listenToState() {
    return moecoObservable((emitter) => {
      consoleLog('listenToState');
      emitter.onNext(BleConnectedState);

      const cb = () => {
        consoleLog('gattserverdisconnected');
        emitter.onNext(BleDisconnectedState);
        emitter.onComplete();
      }

      this.bleDevice.browserbleDevice.addEventListener('gattserverdisconnected', cb, { once: true });
    });
  }

  // onCharacteristicValueChanged(emitter) {
  //   return (ev) => {
  //     consoleLog("characteristicvaluechanged");
  //     const { value } = ev.target;
  //     emitter.onNext(new Int8Array(value.buffer));
  //   }
  // }

  setupNotifications(moecoBleCharacteristic) {
    consoleLog('setupNotifications');
    return moecoSingle(async (singleEmitter) => {
      try {
        const { characteristic, service } = moecoBleCharacteristic;
        const gattService = await this.gattServer.getPrimaryService(service);
        const gattCharacteristic = await gattService.getCharacteristic(characteristic);
        consoleLog('gattCharacteristic');

        gattCharacteristic.startNotifications().then(() => {
          consoleLog('startNotifications');
          const observableResult = moecoObservable(async (emitter) => {
            try {
              gattCharacteristic.addEventListener('characteristicvaluechanged',
                (ev) => {
                  consoleLog('characteristicvaluechanged');
                  const { value } = ev.target;
                  emitter.onNext(new Int8Array(value.buffer));
                });
            } catch (error) {
              emitter.onError(error);
            }
          });
          singleEmitter.onSuccess(observableResult);
        });

      } catch (error) {
        singleEmitter.onError(error);
      }
    });
  } /* Observable<ByteArray> */


  writeCharacteristic(moecoBleCharacteristic, value) {
    return moecoCompletable(async (emitter) => {
      const { characteristic, service } = moecoBleCharacteristic;
      try {
        const gattService = await this.gattServer.getPrimaryService(service);
        const gattCharacteristic = await gattService.getCharacteristic(characteristic);
        await gattCharacteristic.writeValue(new Uint8Array(value));
        emitter.onComplete();
      } catch (error) {
        emitter.onError(error);
      }
    });
  } /* Completable */

  async disconnect() {
    await this.gattServer.disconnect();
  }
}

class BleDevice {
  constructor(browserBleDevice) {
    this.browserbleDevice = browserBleDevice;
    this.address = 'address'; // TODO : Not required ?
    this.name = 'name'; // TODO: Not required ?
    this.manufacturerData = null;
  }
  connect() {
    return moecoSingle(async (emitter) => {
      try {
        const server = await this.browserbleDevice.gatt.connect();
        consoleLog('server', server);
        emitter.onSuccess(new BleConnection(this, server))
      } catch (error) {
        emitter.onError(error)
      }
    });
  }
}


const loggerImpl = {
  logMessage: (tag, msg, logLevel) => {
    console.log(`${logLevel}:${Math.round(new Date().getTime() / 1000).toString()}:${tag}:${msg}`);
  }
}


const getLocationProviderImpl = (store) => {
  if (!store) {
    throw new Error('Store required');
  }
  return {
    provideLocation: () => {
      return moecoSingle((emmiter) => {
        let latitude = 0;
        let longitude = 0;
        if (store.getters['location/location']) {
          latitude = store.getters['location/location'].coords.latitude;
          longitude = store.getters['location/location'].coords.longitude;
        }
        emmiter.onSuccess({
          latitude,
          longitude
        })
      })
    }
  }
}



const getBleScannerImpl = async (store, deviceSelectedCb) => {

  if (!store) {
    throw new Error('Store required');
  }

  if (!store.getters['shipments/sensorUid']) {
    throw new Error('sensor uid is required');
  }

  const browserBleDevice = await startScan(store.getters['shipments/sensorUid'])

  return {
    scanDevices: () => {
      return moecoObservable((emitter) => {
        try {
          if (!store.getters['shipments/sensorUid']) {
            throw new Error('sensor uid is required');
          }

          console.log('sensor uid > > > >', store.getters['shipments/sensorUid']);

          const bleDevice = new BleDevice(browserBleDevice);

          if (deviceSelectedCb) {
            deviceSelectedCb();
          }

          emitter.onNext(bleDevice);
          emitter.onComplete();
        } catch (error) {
          emitter.onError(error);
        }
      });
    }
  }
}

export {
  loggerImpl,
  getBleScannerImpl,
  getLocationProviderImpl
}


/*
// Usage sample

const moecoSdk = new MoecoSdk.io.moeco.sdk.di.MoecoSdk({
  scanDevices: () => {
    const observable = moecoObservable(async (emitter) => {
      try {
        const bleDevice = new BleDevice(await startScan());
        emitter.onNext(bleDevice);
        emitter.onComplete();
      } catch (error) {
        emitter.onError(error);
      }
    });
    return observable;
  }
}, {
  provideLocation: () => moecoSingle((emmiter) => {
    emmiter.onSuccess({
      latitude: 35,
      longitude: 35
    })
  })
}, [{
  logMessage: (tag, msg, logLevel) => {
    console.log(`${Math.round(new Date().getTime() / 1000).toString()}:${tag}:${msg}`);
  }
}]);



const waitUserIneraction = () => new Promise((resolve, reject) => {
  const button = document.createElement("button");
  button.innerHTML = "ble";
  document.body.prepend(button);
  const listener = function (event) {
    const result = moecoSdk.startDeviceSynchronization(null, "56a816ee9a9363cb1622a430dd19822a", { address: "dev-iu2.moeco.ninja", port: 9900 }, () => {
      consoleLog("onSucess")
    }, (err) => {
      consoleLog("ERROR: ", err);
    });
    // Call navigator.bluetooth.requestDevice
    resolve(event);
  }
  button.addEventListener('click', listener, { once: true });
});

waitUserIneraction();
*/
